module.exports = __webpack_public_path__ + "assets/img/columns.c13d7d50.png";